import AttachmentsTable from "components/AttachmentsTable";
import handleChangeFile from "utils/handleChangeFile";
import PropTypes from "prop-types";

function FilesModal(props) {
  const { setFiles, addable } = props;
  return (
    <div>
      {addable && (
        <label
          htmlFor="inventoryFiles"
          className="btn btn--outline btn--add"
          onChange={handleChangeFile.bind(this, { setFiles, reset: true })}
          style={{ width: "fit-content" }}
        >
          إضافة
          <input
            type="file"
            // multiple
            id="inventoryFiles"
            name="files"
            className="d-none"
            accept=".gif,.jpg,.jpeg,.png,.doc,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
        text/plain, application/pdf"
          />
        </label>
      )}
      <AttachmentsTable className={!addable ? "mt-1" : ""} {...props} />
    </div>
  );
}

FilesModal.defaultProps = {
  addable: true,
};

FilesModal.propTypes = {
  setFiles: PropTypes.func.isRequired,
  addable: PropTypes.bool,
};

export default FilesModal;
